import type { PageData } from "../../api";
export function buildPageDataCacheKey(search: string, paramsKey: string, routeId: string): string {
  const query = new URLSearchParams(search);
  query.set("route", routeId);
  const routeParams = JSON.parse(paramsKey) as Record<string, string | undefined>;
  Object.entries(routeParams).forEach(([key, value]) => {
    if (value) query.set(key, value);
  });
  return `/api/spa/page-data?${query.toString()}`;
}
